import { GridCell } from '@progress/kendo-react-grid'
import isNil from 'lodash/isNil'
import React from 'react'

export class PercentageCell extends GridCell {
  public render() {
    const value = this.props.dataItem[this.props.field]
    return <td><span>{!isNil(value) && `${value.toFixed(2)}%`}</span></td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/grid-cell/percentage_cell.tsx